(() => {
  'use strict';
  const films = [...document.querySelectorAll('[data-cr-stock-film]')];
  if (!films.length) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const state = new Map();
  const permitted = () => !reduced.matches && !connection?.saveData && !document.body.classList.contains('p26-motion-paused');
  function update(container) {
    const item = state.get(container);
    const { video, button } = item;
    const play = item.visible && !document.hidden && !item.paused && (permitted() || item.manual);
    if (!play) { video.pause(); return; }
    if (!video.src) video.src = video.dataset.crVideoSource;
    video.muted = true;
    if (video.paused) video.play().catch(() => {
      item.paused = true;
      button.textContent = 'Play video ▶';
      button.setAttribute('aria-label', 'Play background video');
      button.setAttribute('aria-pressed', 'false');
    });
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      state.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= .15;
      update(entry.target);
    });
  }, { threshold: [0, .15] });
  films.forEach(container => {
    const video = container.querySelector('video');
    const button = container.querySelector('button');
    state.set(container, { video, button, visible: false, paused: false, manual: false });
    button.hidden = false;
    const sync = () => {
      const playing = !video.paused;
      container.classList.toggle('is-playing', playing);
      button.textContent = playing ? 'Pause video Ⅱ' : 'Play video ▶';
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
    };
    video.addEventListener('playing', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('error', () => { video.pause(); sync(); button.hidden = true; });
    button.addEventListener('click', () => {
      const item = state.get(container);
      item.paused = !video.paused;
      item.manual = !item.paused;
      update(container);
    });
    observer.observe(container);
  });
  const refresh = () => films.forEach(update);
  document.addEventListener('visibilitychange', refresh);
  reduced.addEventListener('change', () => {
    state.forEach(item => { item.manual = false; }); refresh();
  });
  connection?.addEventListener?.('change', refresh);
  new MutationObserver(() => {
    if (document.body.classList.contains('p26-motion-paused')) state.forEach(item => { item.manual = false; });
    refresh();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
